const forms = {
  onRequest: "Auf Anfrage", // translated
  person: "Person", // translated
  travelDate: "Reise datum", // translated
  cancel: "Absagen", // translated
  getPrice: "Preis bekommen", // translated
  travelDates: "Reisedaten", // translated
};


export default forms;
